<template>
  <div class="row d-flex justify-content-center">
    <div class="col-10 mt-2">
      <el-card shadow="always" class="p-0" style="border-radius: 10px;" :body-style="{ padding: '0px' }"
        v-loading="loading">
        <div class="row bg-navy py-2 px-3 mb-5">
          <div class="col-12 text-center">
            <h3 class="mb-0 text-white text-uppercase">Contact Details</h3>
          </div>
        </div>
        <div class="mx-5">
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-5" v-for="(guarantor, index) in guarantors" v-bind:key="index">
              <div class="row">
                <h2 class="col-12 text-center text-navy mb-3 text-uppercase">Contact {{ index + 1 }}</h2>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">First Name</div>
                <div class="col-8 p-1"><el-input v-model="guarantor.first_name" size="small" /></div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Last Name</div>
                <div class="col-8 p-1"><el-input v-model="guarantor.last_name" size="small" /></div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Email</div>
                <div class="col-8 p-1"><el-input v-model="guarantor.email" size="small" /></div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Phone Number</div>
                <div class="col-8 p-1"><el-input v-model="guarantor.phone" size="small" /></div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Address</div>
                <div class="col-8 p-1">
                  <google-maps-autocomplete class="w-100" style="height: 32px;" :value="guarantor.postal_address"
                    v-on:address-components="saveAddresses($event, guarantor)" placeholder=""></google-maps-autocomplete>
                </div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Date of birth</div>
                <div class="col-8 p-1"><el-date-picker v-model="guarantor.date_of_birth" value-format="yyyy-MM-dd"
                    format="dd/MM/yyyy" type="date" class="w-100" placeholder="Pick a day" size="small"></el-date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-12 text-right">
              <el-button class="action-btn text-uppercase" type="primary" @click="onSubmit(0)">
                Proceed
              </el-button>
              <el-button class="action-btn text-uppercase btn-green" type="primary" @click="onSubmit(1)">
                Save progress
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import Guarantor from "../../../modelsPortal/Guarantor";
import Business from "../../../modelsPortal/Business";
export default {
  props: {
    initial_business: {
      type: Object,
    },
  },
  mounted() {

  },
  data() {
    return {
      guarantors: this.initial_business && this.initial_business.guarantors ?
        this.initial_business.guarantors :
        [],
      loading: false,
      min_guarantors: 2,
    };
  },
  mounted() {
    this.getGuarantors();
  },
  methods: {
    getGuarantors() {
      let num_guarantors = this.guarantors.length;
      console.log(num_guarantors);
      for (let index = num_guarantors; index < this.min_guarantors; index++) {
        this.guarantors.push({
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          postal_address: '',
          date_of_birth: '',
          extra_attributes: {
            postal_address: null,
          },
        });

      }
    },
    onSubmit: function (save_progress) {
      this.loading = true;
      let promises = [];
      this.guarantors.forEach(guarantor => {
        if (!guarantor.first_name && !guarantor.email)
          return;
        promises.push(
          new Guarantor(guarantor).for(new Business(this.initial_business))
            .save()
            .then(res => {
              guarantor = res;
              return true;
            })
            .catch(errors => {
              return false;
            })
        );
      });

      Promise.all(promises).then((responseList) => {
        this.loading = false;
        if (responseList.length < this.min_guarantors && !save_progress) {
          this.$message.error('Please complete your contact details.');
        } else if (responseList.filter(x => x == false).length == 0) {
          if (!save_progress) {
            this.initial_business.onboarding_step++;
            new Business(this.initial_business).save();

            this.$emit('save-data', this.business);
          } else {
            this.$message.success('Saved Successfully!');
          }
        } else {
          this.$message.error('There is an issue please try again.');
        }
      });

    },
    saveAddresses: function (address, guarantor) {
      guarantor.extra_attributes.postal_address = address;
    },
  },
};
</script>